// Brand imagery provided by the chapter (pink & green, pearls, ivy, gold lines)
// Decorative PNGs are checkerboard-keyed to true transparency; hero is a photo.
export const ASSETS = {
  hero: "/brand/hero.jpg",
  goldLines: "/brand/goldLines.png",
  ivy: "/brand/ivy.png",
  pearls: "/brand/pearls.png",
  wave: "/brand/wave.png",
};
